import styled from 'styled-components';

import { PillAction } from '@xsolla/ui-core';

import { MailchimpIcon } from '../../ui/icons';

export const MailchimpPill = styled(PillAction)`
  display: flex;
  align-items: center;
  padding-left: 26px;
`;

export const WrappedMailchimpIcon = styled(MailchimpIcon)`
  margin-right: 8px;
`;

export const MailchimpPillTitle = styled.div`
  padding-right: 8px;
  margin-right: 4px;
  border-right: 1px solid ${(props) => props.theme.colors.stroke};
`;

export const MailchimpWrapper = styled.div`
  width: 402px;
`;

export const MailchimpTitle = styled.div`
  ${(props) => props.theme.typography.title2};
  margin-bottom: 8px;
`;

export const MailchimpDescription = styled.div`
  ${(props) => props.theme.typography.description};
  color: ${(props) => props.theme.colors.muted};
  margin-bottom: 16px;
`;
